<template>
  <div id="scaleBox">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { getChannelSellerInfo, getMenus } from "@/api/testLogin/index";
export default {
  name: "App",
  computed: {
    ...mapGetters(["scaleValue"]),
  },
  mounted() {
    this.getSellerInfo();
    this.getMenusData();
    this.$nextTick(() => {
      window.addEventListener("resize", this.resize);
      this.resize();
    });
  },
  methods: {
    ...mapMutations(["setScaleValue"]),
    getSellerInfo() {
      getChannelSellerInfo()
        .then((res) => {
          if (res.code === 200) {
            this.$store.dispatch("updateUserInfo", res.data);
          }
        })
        .catch(() => {});
    },
    getMenusData() {
      getMenus()
        .then((res) => {
          if (res.code === 200) {
            let vdata = res.data;
            let fistMenuList = [];
            let childMenuList = [];
            vdata.forEach((item) => {
              fistMenuList.push({
                name: item.title,
                path: item.path,
              });
              if (!!item.children) {
                childMenuList.push(this.transformData(item.children));
              }
            });
            this.$store.dispatch("updateFistMenuList", fistMenuList);
            this.$store.dispatch("updateChildMenuList", childMenuList);
          }
        })
        .catch(() => {});
    },
    transformData(data) {
      return data.map((item) => ({
        name: item.title,
        path: `/${item.path}`,
        menuType: item.menuType,
        // menuType: "M",
        children:
          item.children && item.children.length > 0
            ? this.transformData(item.children)
            : null,
      }));
    },
    resize() {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const scale = (w < 1440 ? 1440 : w) / 1920;
      // 设置属性
      const scaleDom = document.getElementById("scaleBox");
      scaleDom.style.transform = `scale(${scale})`;
      scaleDom.style.height = `${h / scale}px`;
      scaleDom.style.width = `${w / scale}px`;
      this.setScaleValue(scale);
      document.body.style.setProperty("--scale", scale);
      document.body.style.setProperty("--scale-max", scale > 1 ? 1 : scale);
    },
  },
};
</script>

<style lang="scss" scoped>
#scaleBox {
  transform-origin: left top;
}
</style>